export const toPathArray = (path: string): string[] => path.split('.').filter(Boolean)
